import { FlatListProps } from "react-native";
import LFlatList from "./LFlatList";
import LText from "./LText";
import LBox from "./LBox";

type Item =
  | ({
      id: string;
    } & Record<string, any>)
  | undefined;
interface CarouselProps<T extends Item> extends FlatListProps<T> {
  title?: string;
}

const Carousel = <T extends Item>({
  title,
  renderItem,
  ...rest
}: CarouselProps<T>) => {
  return (
    <LBox>
      {title ? (
        <LText mb="s4" paddingHorizontal="s4" variant="carouselTitle">
          {title}
        </LText>
      ) : null}
      <LFlatList
        {...rest}
        contentContainerStyle={{ flexGrow: 1 }}
        disableAutomaticPadding
        horizontal
        keyExtractor={(item, index) =>
          item?.id ? `${title}-${item.id}` : `${title}-${index.toString()}`
        }
        ListFooterComponent={<LBox paddingHorizontal="s2" />}
        ListHeaderComponent={<LBox paddingHorizontal="s2" />}
        renderItem={({ item, index }) => (
          <LBox
            mr={rest.data && index !== rest.data.length - 1 ? "s3" : "zero"}
          >
            {renderItem?.({
              item,
              index,
              separators: {
                highlight: () => {},
                unhighlight: () => {},
                updateProps: () => {},
              },
            })}
          </LBox>
        )}
        showsHorizontalScrollIndicator={false}
        style={{ flexGrow: 0, flexDirection: "row", width: "100%" }}
      />
    </LBox>
  );
};

export default Carousel;
